import React from 'react';
import { useInView } from 'react-intersection-observer';

const FeatureShowcase = ({ title, description, imageUrl, imagePosition = 'left' }) => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    return (
        <div
            ref={ref}
            className={`flex flex-col ${imagePosition === 'right' ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-8 transition-all duration-1000 ease-in-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
        >
            <div className="md:w-1/2">
                <img
                    src={imageUrl}
                    alt={title}
                    className="w-full h-auto rounded-lg shadow-lg object-cover"
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://via.placeholder.com/600x400?text=功能圖片';
                    }}
                />
            </div>

            <div className="md:w-1/2">
                <h3 className="text-2xl font-bold mb-4">{title}</h3>
                <p className="text-gray-600">{description}</p>
            </div>
        </div>
    );
};

export default FeatureShowcase;